<div 
    class="container-menu-left" 
    [class.close]="!menuLeftService.menuLeftOpen()">

    <!-- Button toggle menu left -->
    <div 
        class="container-button-toggle" 
        [raTooltip]="{ text: ('menuLeft.toggleTooltip' | translate), position: 'bottom' }"
        [class.close]="!menuLeftService.menuLeftOpen()" 
        (click)="menuLeftService.toggleMenuLeft()">
        <ra-icon [icon]="'arrow-left'" [varColor]="'contentPrimary'" [size]="16" />
    </div>

    <!-- Logo -->
    <div class="container-logo">
        <img
            src="images/logo.png"
            alt="RapiDocs"
            [attr.title]="'menuLeft.brandName' | translate" />
        
        <!-- Se o menu tiver aberto, exibir o nome da empresa -->
        <h1 [class.hidden]="!menuLeftService.menuLeftOpen()">{{ 'menuLeft.brandName' | translate }}</h1>
    </div>

    <!-- Options -->
    <div class="container-items-options">

        <!-- Navegação agrupada por seção -->
        <div class="container-options">
            @for (group of groups(); track group.labelKey) {
                <span class="section-label" [class.hidden]="!menuLeftService.menuLeftOpen()">
                    {{ group.labelKey | translate }}
                </span>

                @for (option of group.items; track option.route) {
                    @let badgeCount = option.badge?.() ?? 0;

                    <div
                        class="options"
                        [class.close]="!menuLeftService.menuLeftOpen()"
                        [class.disabled]="option.disabled"
                        [routerLink]="option.disabled ? null : option.route"
                        [routerLinkActive]="'active'"
                        [raTooltip]="{
                            text: (option.tooltipKey ?? option.labelKey) | translate,
                            position: 'right'
                        }"
                        (click)="!option.disabled ? option.function?.() : null">
                        <!-- Recolhido o contador some, então o azul no ícone é o que sinaliza a pendência -->
                        <ra-icon
                            [icon]="option.icon"
                            [size]="16"
                            [varColor]="badgeCount > 0 ? 'primary' : 'contentSecondary'" />

                        <span
                            class="ra-label-s"
                            [class.hidden]="!menuLeftService.menuLeftOpen()">{{ option.labelKey | translate }}
                        </span>

                        @if (badgeCount > 0) {
                            <span
                                class="badge-count"
                                [class.hidden]="!menuLeftService.menuLeftOpen()">{{ badgeCount }}</span>
                        }
                    </div>
                }
            }
        </div>

        <!-- Rodapé: plano atual + logout. O resto da navegação está nas seções acima. -->
        <div class="container-bottom">

            <!-- Chip do plano vigente: plano + ciclo de cobrança sempre à vista -->
            @let chip = planChip();
            @if (chip) {
                @let chipCycle = chip.cycleKey ? (chip.cycleKey | translate) : '';
                @let chipLabel = chipCycle ? chip.planTitle + ' · ' + chipCycle : chip.planTitle;
                @let chipMeta = chip.periodEnd
                    ? ((chip.periodKey ?? '') | translate : { date: (chip.periodEnd | date : 'shortDate') })
                    : '';
                <!-- Recolhido sobra só o ícone, então o tooltip carrega o texto inteiro -->
                @let chipTooltip = chipMeta ? chipLabel + ' · ' + chipMeta : chipLabel;

                <div
                    class="plan-chip"
                    [class.close]="!menuLeftService.menuLeftOpen()"
                    [class.clickable]="!!chip.route"
                    [routerLink]="chip.route"
                    [raTooltip]="{ text: chipTooltip, position: 'right' }">

                    <!-- Linha 1: ícone + plano -->
                    <div class="chip-top">
                        <ra-icon [icon]="'crown'" [size]="16" [varColor]="'primary'" />

                        <span
                            class="chip-plan ra-label-s"
                            [class.hidden]="!menuLeftService.menuLeftOpen()">{{ chipLabel }}</span>
                    </div>

                    <!-- Linha 2: renovação. Fora da linha do ícone justamente para
                         usar a largura toda do chip — com o recuo, a data truncava. -->
                    @if (chipMeta) {
                        <span
                            class="chip-meta ra-label-xs"
                            [class.hidden]="!menuLeftService.menuLeftOpen()">{{ chipMeta }}</span>
                    }
                </div>
            }

            <div
                class="options"
                [class.close]="!menuLeftService.menuLeftOpen()"
                [raTooltip]="{ text: ('menuLeft.logout' | translate), position: 'right' }"
                (click)="authController.logout()">
                <ra-icon [icon]="'logout'" [varColor]="'contentSecondary'" [size]="16" />

                <span [class.hidden]="!menuLeftService.menuLeftOpen()">{{ 'menuLeft.logout' | translate }}</span>
            </div>
        </div>
    </div>
</div>
